// extracted by mini-css-extract-plugin
export default {"loadingIcon":"spinner_loadingIcon__5RCWw","spinner":"spinner_spinner__6LOe0","spin":"spinner_spin__zo8Zl"};